import React from "react";
import { StyleSheet, View } from "react-native-web";
import { Constants } from "../../../../config";
import { IconizedButton } from "../../../atoms";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import { getClass } from "../../../../helpers/formatHelpers";
import dynamic from "next/dynamic";

const ExternalWeb = dynamic(() =>
  import("../../../../modules/common/ExternalWeb")
);

const MapContainer = (props) => {
  const { t } = useTranslation();
  const {
    location,
    address,
    accomodationUrl,
    transportUrl,
    mapLink,
    isMobileVersion,
  } = props;
  const region = {
    ...location,
    latitudeDelta: 0.0922,
    longitudeDelta: 0.0421,
  };
  const navigation = useRouter();

  const onOpenExternalLink = (url) => {
    var win = window.open(url, "_blank");
    win.focus();
  };
  const onButtonAction = (actionType) => {
    if (actionType == Constants.actionType.ACTION_GOOGLE_MAP) {
      onOpenExternalLink(mapLink);
      return;
    }
    let tabIndex = 0;
    if (actionType == Constants.actionType.ACTION_MAP) {
      tabIndex = 0;
    } else if (actionType == Constants.actionType.ACTION_ACCOMODATION) {
      tabIndex = 1;
    } else if (actionType == Constants.actionType.ACTION_TRANSPORT) {
      //tabIndex = 2;
      onOpenExternalLink(transportUrl);
      return;
    }

    navigation.push({
      pathname: "/map/MapScreen",
      query: {
        accomodationUrl: accomodationUrl,
        transportUrl: transportUrl,
        region: region,
        address: address,
        tabIndex: tabIndex,
      },
    });

    // navigation.navigate("MapScreen", {
    //   region: region,
    //   address: address,
    //   tabIndex,
    //   accomodationUrl: accomodationUrl,
    //   transportUrl: transportUrl,
    // });
  };
  return (
    <View style={[styles.container, props.style]}>
      <View
        style={[
          styles.buttonContainer,
          isMobileVersion ? { padding: 14 } : {},
        ]}>
        <IconizedButton
          filled
          isHeading
          buttonTitle={t("key_button_google_map")}
          style={{ flex: 1, height: isMobileVersion ? 24 : 40 }}
          fontSize={isMobileVersion ? 10 : 16}
          onPress={() => {
            onButtonAction(Constants.actionType.ACTION_GOOGLE_MAP);
          }}
          filledTextColor={getClass("btn-text-black")}
          isMobileVersion={isMobileVersion}
        />
        <IconizedButton
          filled
          isHeading
          buttonTitle={t("key_button_transport")}
          style={{
            flex: 1,
            height: isMobileVersion ? 24 : 40,
            marginLeft: isMobileVersion ? 10 : 30,
          }}
          fontSize={isMobileVersion ? 10 : 16}
          // disabled={true}
          onPress={() => {
            onButtonAction(Constants.actionType.ACTION_TRANSPORT);
          }}
          filledTextColor={getClass("btn-text-black")}
          isMobileVersion={isMobileVersion}
        />
      </View>
      <ExternalWeb url={accomodationUrl} isMobileVersion={isMobileVersion} />

      {/**
      <TouchableOpacity
        style={styles.expandMapButton}
        onPress={() => {
          onButtonAction(Constants.actionType.ACTION_MAP);
        }}
      >
        <CImage
          style={styles.expandIcon}
          source={Images.iconExpandMap}
          resizeMode="contain"
          width={15}
          height={15}
          layout="fixed"
        />
      </TouchableOpacity>
       */}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: getClass("bg-gray1"),
    alignSelf: "stretch",
    position: "relative",
    borderRadius: 20,
  },
  buttonContainer: {
    paddingVertical: 20,
    paddingHorizontal: 30,
    width: "100%",
    flexDirection: "row",
    top: 0,
    left: 0,
  },
  expandMapButton: {
    width: 45,
    height: 45,
    position: "absolute",
    right: 20,
    bottom: 20,
    backgroundColor: "white",
    borderRadius: 25,
    alignItems: "center",
    justifyContent: "center",
  },
  expandIcon: {
    width: 21,
    height: 21,
  },
});

export default MapContainer;
